import type { ReactiveVar } from '@apollo/client'
import { makeVar } from '@apollo/client'

// Create a reactive variable to store workspace data
export const currentWorkspaceVar: ReactiveVar<string | null> = makeVar<string | null>(null)
